import Form from "componentsv2/form/Form";
import { cn } from "tools/ui";

const base = "grid gap-x-2 mb-auto rounded-lg h-full";

function GridFields(props) {
  const { field, record, layout, parentRec, handleButton } = props;
  let style = "";
  let cols = "";
  let rows = "";
  let colspan = "";
  let border = "";
  if (field.border === "visible") {
    border = "border border-dashed border-stone-400 px-2";
  }

  if (props.colSpan) {
    colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";
  }

  return (
    <div
      key={field.id}
      className={cn(base, colspan, cols, rows, style, border)}
    >
      {Form({
        keyName: field.name,
        layout: layout,
        form: field.grid,
        handleButton: handleButton,
        record: record,
        parentRec: parentRec,
      })}
    </div>
  );
}

export default GridFields;
